import type { IDirectoriesStorage } from 'src/services/directories-storage-service/directories-storage-service';
import type { TCalculatedValueView } from 'src/services/directory-service/types';

import { handleValueSourceRule } from './handle-value-source-rule';

export const handleCalculatedValueRule = (
  directories: IDirectoriesStorage,
  recordData: Record<string, unknown>,
  ruleView: TCalculatedValueView,
): { value: unknown } => {
  const { valuesByPseudonims } = handleValueSourceRule(directories, recordData, ruleView.valueSource.sources);

  const args = Object.keys(valuesByPseudonims).join(', ');
  const values = Object.values(valuesByPseudonims);
  const getValue = new Function(args, ruleView.body);
  const calculatedValue: unknown = getValue(...values);

  return { value: calculatedValue };
};
